import { GHIN_STAGING_URL } from './config';

const LOGIN_PATH = 'users/login.json';

// Token cache
let cachedToken: string | null = null;
let tokenExpiration: number | null = null;

// Cache token for 23 hours (1 hour buffer before 24-hour expiration)
const TOKEN_LIFETIME_MS = 23 * 60 * 60 * 1000;

export function getToken(): string | null {
  if (cachedToken && tokenExpiration && Date.now() < tokenExpiration) {
    return cachedToken;
  }
  cachedToken = null;
  tokenExpiration = null;
  return null;
}

export function clearToken(): void {
  cachedToken = null;
  tokenExpiration = null;
}

export interface GhinLoginRequest {
  email: string;
  password: string;
}

export interface GhinLoginResponse {
  success: boolean;
  status: number;
  data?: unknown;
  error?: string;
}

export async function ghinLogin(request: GhinLoginRequest): Promise<GhinLoginResponse> {
  const response = await fetch(`${GHIN_STAGING_URL}/${LOGIN_PATH}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        email: request.email,
        password: request.password,
        remember_me: 'true',
      },
    }),
  });

  const data = await response.json();

  if (response.ok && data.token) {
    cachedToken = data.token;
    tokenExpiration = Date.now() + TOKEN_LIFETIME_MS;
    return {
      success: true,
      status: response.status,
      data,
    };
  }

  return {
    success: false,
    status: response.status,
    error: data.message || 'Login failed',
  };
}
